import { useEffect } from 'react';
import { APIError } from '@tajawal/web-core-sdk-v2/lib/utils/sentry.utils';
import type FlightInfoStore from '@tajawal/web-flights-sdk/lib/stores/flight-info.store';

export default function useFetchRichContent({
  flightInfoStore,
  amenitiesCodes,
  baggageDimensionCodes,
  baggageWeightCodes,
  airlineRefundCodes,
  shouldFetch = true,
}: {
  flightInfoStore: FlightInfoStore;
  amenitiesCodes?: string[];
  baggageDimensionCodes?: string[];
  baggageWeightCodes?: string[];
  airlineRefundCodes?: string[];
  shouldFetch?: boolean;
}): void {
  useEffect(() => {
    function handleError(error) {
      // @ts-ignore
      APIError({
        error,
        payload: { amenitiesCodes, baggageDimensionCodes, baggageWeightCodes, airlineRefundCodes },
        tag: 'RESOURCES_CLIENT_FETCH_ERROR',
      });
    }

    /**
     * amenities and baggage dimensions fetch
     */
    if (shouldFetch) {
      flightInfoStore.richContent.fetch({
        amenitiesCodes,
        baggageDimensionCodes,
        baggageWeightCodes,
        airlineRefundCodes,
        errorHandler: handleError,
      });
    }
  }, [amenitiesCodes, baggageDimensionCodes, baggageWeightCodes, airlineRefundCodes, shouldFetch]);
}
